import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OperationsService } from 'src/app/core/services/operations.service';
import { HelpersService } from '../../core/services/helpers.service';
import { DatiPignoramentoAdapter } from '../components/fascicolo/dati-pignoramento-view/dati-pignoramento-adapter';
import { DatiPignoramento } from '../models/dati-pignoramento/dati-pignoramento';
import { FormValidationService } from '../services/form-validation.service';
import { NumericOperationManager } from '../utils/numeric-operation-manager';
import { BaseForm } from './base-Form';

export abstract class DatiPignoramentoFormComponent extends BaseForm {
  request: DatiPignoramento;
  form: FormGroup;

  constructor(protected operationService: OperationsService,
              protected campiForm: FormBuilder,
              protected helpers: HelpersService,
              protected formValidationService: FormValidationService) {
    super();
  }

  createForm() {
    this.request = DatiPignoramentoAdapter.createRequest(this.getDatiPignoramento());
    this.form = this.campiForm.group({
        terzo: [this.request.terzo, Validators.required],
        importoPrecettato: [this.request.importoPrecettato, Validators.required],
        pignorato: [this.request.pignorato, Validators.required],
        cf: [this.request.cf],
        sede: [this.request.sede],
        pec: [this.request.pec],
        sommaPignorata: [this.request.sommaPignorata],
        note: [this.request.note]

     });
  }


  update() {
    this.getRequest(DatiPignoramentoAdapter.createRequest(this.request));
  }

  getDiff(a: string, b: string) {
    return NumericOperationManager.getDiff(a, b);
  }

  abstract getDatiPignoramento(): DatiPignoramento;
  abstract getRequest(datiPignoramento: DatiPignoramento);
}
